import { CardSvg } from '@/play/cardSvg'

/** Home card art: a dark stage, a warm cone of light, a creature and its long shadow on the wall. */
export function SpotlightCardArt() {
  return (
    <CardSvg bg="#141824">
      {(id) => (
        <>
          <defs>
            <radialGradient id={id('pool')} cx="0.5" cy="0.5" r="0.5">
              <stop offset="0" stopColor="#ffe2b0" stopOpacity="0.95" />
              <stop offset="0.7" stopColor="#ffc27a" stopOpacity="0.55" />
              <stop offset="1" stopColor="#ffc27a" stopOpacity="0" />
            </radialGradient>
            <linearGradient id={id('beam')} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stopColor="#ffd9a0" stopOpacity="0.55" />
              <stop offset="1" stopColor="#ffd9a0" stopOpacity="0.08" />
            </linearGradient>
          </defs>
          {/* back wall and floor */}
          <rect x="20" y="30" width="280" height="110" fill="#262b3a" />
          <rect x="0" y="140" width="320" height="60" fill="#1d2130" />
          {/* the pool of light */}
          <ellipse cx="170" cy="120" rx="120" ry="70" fill={`url(#${id('pool')})`} />
          {/* the long shadow of the creature on the wall */}
          <rect x="196" y="58" width="44" height="82" rx="10" fill="#141824" opacity="0.75" />
          {/* the creature */}
          <rect x="150" y="96" width="30" height="58" rx="6" fill="#ff7a66" />
          <circle cx="160" cy="110" r="7" fill="#ffffff" />
          <circle cx="174" cy="110" r="7" fill="#ffffff" />
          <circle cx="157" cy="107" r="3.4" fill="#1d2b36" />
          <circle cx="171" cy="107" r="3.4" fill="#1d2b36" />
          {/* the beam and the lamp */}
          <path d="M72 34 L 250 76 L 96 182 Z" fill={`url(#${id('beam')})`} opacity="0.6" />
          <circle cx="66" cy="28" r="14" fill="#2b2f3a" />
          <circle cx="72" cy="34" r="8" fill="#fff0c8" />
        </>
      )}
    </CardSvg>
  )
}
